
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#5F6368","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M16 14c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zM27 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zM5 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zM9 26.092v-5.95C9 16.748 12.11 14 15.947 14h.106C19.89 14 23 16.749 23 20.141V26a477.999 477.999 0 0 0-6.769 0c-2.41.015-4.82.046-7.231.092zM23 22.11v-3.016C23 16.833 24.777 15 26.97 15h.06c2.193 0 3.97 1.833 3.97 4.094v2.956a8.423 8.423 0 0 1-3.868.95c-1.377.01-2.755-.286-4.132-.89zM1 22.11v-3.016C1 16.833 2.777 15 4.97 15h.06C7.223 15 9 16.833 9 19.094v2.956a8.423 8.423 0 0 1-3.868.95c-1.377.01-2.755-.286-4.132-.89z"}})])])
          )
        }
      }
    